import { useTranslation } from 'react-i18next'
import { Badge } from '@/components/ui/badge'
import type { BadgeProps } from '@/components/ui/badge'
import type { FeedbackStatus } from '@/types/feedback'

const VARIANTS: Record<FeedbackStatus, BadgeProps['variant']> = {
  received: 'secondary',
  in_progress: 'info',
  resolved: 'success',
  not_planned: 'outline',
}

export function FeedbackStatusBadge({ status }: { status: FeedbackStatus }) {
  const { t } = useTranslation('feedback')
  return <Badge variant={VARIANTS[status]}>{t(`statuses.${status}`)}</Badge>
}

export function AwaitingReplyBadge() {
  const { t } = useTranslation('feedback')
  return <Badge variant="warning">{t('awaitingReply')}</Badge>
}
